'use client';
import {useEffect, useState} from "react";
import {useAtom} from "jotai";
import {seenProductsAtom} from "@/store/seen-products";
import {Collapsible, CollapsibleContent, CollapsibleTrigger} from "@/shadcn/components/ui/collapsible";
import {cn} from "@/lib/utils";
import {Button} from "@/shadcn/components/ui/button";
import {ChevronDown, ChevronUp} from "lucide-react";
import {Variant} from "@/types";
import VariantCard from "@/components/variants/variant-card";

export const VariantsLastSeen = () => {
    const [lastSeenCollapsibleOpen, setLastSeenCollapsibleOpen] = useState(false);
    const [seenProducts, setSeenProducts] = useAtom<Variant[]>(seenProductsAtom);

    // Load seen products from localStorage on mount
    useEffect(() => {
        const storedProducts = JSON.parse(localStorage.getItem("seen_products") || "[]");
        // @ts-expect-error - ignore this
        setSeenProducts(storedProducts);
    }, [setSeenProducts]);

    if (seenProducts.length === 0) return null;

    return (
        <section className="mt-4 bg-white rounded-xl p-4 lg:p-5">
            <h2 className="font-extrabold text-base md:text-lg tracking-tight text-slate-900 mb-3">
                <span className="inline-block border-b-2 border-amber-500 pb-1">Kürzlich angesehen</span>
            </h2>
            <div className="">
                <div className="w-full flex flex-col items-center">
                    <div className="w-full mx-auto p-0">
                        {/* Display search terms if they exist */}
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-1 sm:gap-4 md:py-4">
                            {seenProducts.slice(0, 4).map((variant: Variant) => (
                                <VariantCard key={variant.variant_id} variant={variant}/>
                            ))}
                        </div>
                    </div>
                </div>
                {seenProducts.length > 4 && (
                    <Collapsible open={lastSeenCollapsibleOpen}>
                        <CollapsibleContent
                            className={cn("text-popover-foreground outline-hidden data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2")}
                        >
                            <div className="w-full flex flex-col items-center">
                                <div className="w-full mx-auto p-0">
                                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-1 sm:gap-4 py-4">
                                        {seenProducts.slice(4).map((variant) => (
                                            <VariantCard key={variant.variant_id} variant={variant}/>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </CollapsibleContent>
                        <CollapsibleTrigger asChild>
                            {lastSeenCollapsibleOpen ? (
                                <Button type={'button'} variant="outline" size="sm" className="w-full mt-2" onClick={() => setLastSeenCollapsibleOpen(false)}>
                                    Weniger anzeigen
                                    <ChevronUp className="h-4 w-4 ml-2"/>
                                </Button>
                            ) : (
                                <Button type={'button'} variant="outline" size="sm" className="w-full mt-2" onClick={() => setLastSeenCollapsibleOpen(true)}>
                                    Mehr anzeigen
                                    <ChevronDown className="h-4 w-4 ml-2"/>
                                </Button>
                            )}
                        </CollapsibleTrigger>
                    </Collapsible>
                )}

            </div>
        </section>
    )
}
